var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSadBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1F0",
  d: "M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFA39E",
  d: "M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SadBadge_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#F5222D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.665 14.667s-1-1.333-2.666-1.333c-1.667 0-2.667 1.333-2.667 1.333M13.999 10h.006M10 10h.006m8.66 2a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0m-4.333-2a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m-4 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "SadBadge_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 4h16v16H4z"
})))));
export { SvgSadBadge as ReactComponent };
export default __webpack_public_path__ + "assets/images/SadBadge.c903ad1073440ce7e29e38b3d43482e7.svg";